<template>
    <div class="grid" v-if="getMovil() == null">
		<div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
			<Message severity="error" class="p-col-12">
				Para poder operar en el sistema debe seleccionar el móvil donde está cumpliendo funciones.
			</Message>
		</div>
	</div>
    <div class="grid" v-if="getMovil() != null">
		<div class="col-12 md:col-6 xl:col-3">
			<div class="card grid-nogutter widget-overview-box widget-overview-box-1">
				<span class="overview-icon">
					<i class="pi pi-ticket"></i>
				</span>
				<span class="overview-title">Registro de entrega por código alfanumérico</span>
				<div class="grid overview-detail">
					<div class="col-12">
						<div class="overview-subtext">Registre aquí todas las entregas realizadas a beneficiaros que presenten código alfanumérico.</div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid p-mt-5">
			<div class="col-12">
				<div class="card">
                    <Toast/>
                    <Message severity="warn" class="p-col-12">
                        El lugar seleccionado para operar el sistema es {{getNombre()}}. Para modificarlo ir a la sección Datos de Sesión -> Punto móvil.    
                    </Message>
                    <div class="p-fluid p-formgrid p-grid p-mt-5 p-mb-2">
                        <div class="p-field p-col-12 p-md-6">
                            <label for="motivos">Código alfanumérico</label>
                            <div class="p-grid">
                                <div class="p-col-12 p-md-8 p-mt-3">
                                    <InputText v-model="codigo" :class="{'p-invalid': (submittedCode && !codigo) || (submittedCode && error)}"/>
                                </div>
                                <div class="p-col-12 p-md-4 p-mt-3">
                                    <Button label="Obtener información" @click="getInfo()" class="p-button-outlined p-button-info" />
                                </div>
                            </div>
                            <small class="p-invalid" v-if="submittedCode && !codigo">Se requiere ingresar un código alfanumérico válido.</small>
                            <small class="p-invalid" v-if="submittedCode && codigo && error">El código alfanumérico debe tener 6 caracteres.</small>
                        </div>
                        <div class="p-field p-col-12 p-md-6">
                            <Fieldset legend="Información del beneficiario" v-if="data && !beneficiario">
                                <Tag class="mr-2" severity="danger" value="El Código proporcionado es inválido"></Tag>
                            </Fieldset>
                            <Fieldset legend="Información del beneficiario" v-if="data && beneficiario">
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Nombre:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.nombre}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Cédula de Identidad:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.ci}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Fecha nacimiento:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    {{beneficiario.nacimiento}}
                                </div>
                            </div>
                            <div class="p-grid p-mt-3">
                                <div class="p-col-12 p-md-6">
                                    Cantidad de viandas:
                                </div>
                                <div class="p-col-12 p-md-6">
                                    <Badge :value="getViandas()" severity="success" size="large"></Badge>
                                </div>
                            </div>
                        </Fieldset>
                        </div>
                    </div>
                    <Toolbar>
                        <template v-slot:left>
                            <Button label="Limpiar" @click="clearAll()" icon="pi pi-eraser" class="p-button-secondary" iconPos="left"/>
                        </template>

                        <template v-slot:right>
                            <Button label="Entregar" @click="entregar()" icon="pi pi-angle-right" iconPos="left"/>
                        </template>
                    </Toolbar>
				</div> 
			</div>
		</div>
	</div>	

	<Dialog header="Aguarde..." v-model:visible="wait" :style="{width: '150px'}" :modal="true" :position="left">
		<div align="center">
			<ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
		</div>
	</Dialog>
	
</template>

<script>
/* import SmartService from '../service/SmartService'; */
export default {
	data() {
		return {
			wait: false,
            codigo: null,
            error: false,
            submittedCode: false,
            beneficiario: null,
            data: false,
            persona: {
                "id":1,
                "ci":"3310962-9",
                "nombre":"Sebastián Nicolás Ressi Prieto",
                "nacimiento": "1978-08-07",
                "viandas": 4,
            },
		}
	},	
	smartService: null,
	created() {
		/* this.smartService = new SmartService(); */
	},
	mounted() {

	},
	methods: {
        getMovil(){
            return localStorage.movil_id;
        },

        getNombre(){
            return localStorage.movil_name;
        },

        getViandas(){
            return this.beneficiario.viandas;
        },

        entregar(){
            this.registrarCodigo();
        },

        clearAll(){
            this.submittedCode = false;
            this.data = false;
            this.error = false;
            this.beneficiario = null;
            this.codigo = null;
        },

        async getInfo(){
            this.wait= true;
            this.submittedCode = true;
            this.error = false;
            if (this.codigo){
                if (this.codigo.length != 6) 
                this.error = true;
                else{
                    this.beneficiario = this.persona;
                    this.data = true;
                }
            }
            this.wait= false;
        },

        async registrarCodigo() {
			this.submittedCode = true;
			this.wait= true;
            if (this.codigo && this.codigo.length != 6) 
                this.error = true;
			if (this.codigo && !this.error) {
                if (this.beneficiario){
                    /* this.$router.replace({ name: "confirmacionC", params: {form: {postulacion: this.form2.postulacion}}}); */ 
                    /* console.log("Motivo: " + this.motivo);
                    console.log("Cantidad: " + this.cantidad); */
                    this.$toast.add({severity:'success', summary: 'Registro exitoso', detail:'La entrega fue registrada sin incovenientes.', life: 3000});
                }
                else
                    this.$toast.add({severity:'error', summary: 'Código inválido', detail:'El código proporcionado carece de validez.', life: 3000});
			}
			this.wait= false;
		},
		
	},
}
</script>

<style scoped lang="scss">
	.overview-detail {
        text-align: left;
        margin-top: 2rem;

        .p-col-6 {
            padding: .5rem;
        }
    }
</style>